export default __webpack_public_path__ + "static/media/scraper_central_v1_600px.34ba24cb.png";